import React from 'react';
import {
  Orientation,
  RowSizes,
  PageFormats,
  PageFormatTitles,
} from 'shared/constants/Export';
import { Map } from 'immutable';
import capitalize from 'underscore.string/capitalize';
import Dropdown from 'shared/components/menus/dropDown';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

export default React.createClass({
  displayName: 'PDFExportLayoutOptions',

  render() {
    const { form, onClick } = this.props;

    return (
      <div>
        <h2 className="pdf-side-panel-title">Document customization</h2>
        <RadioToggle
          title="Page Orientation"
          form={form}
          field="orientation"
          firstValue={Orientation.portrait}
          secondValue={Orientation.landscape}
          onClick={onClick}
        />
        <RadioToggle
          title="Row Size"
          form={form}
          field="rowSize"
          firstValue={RowSizes.Comfortable}
          secondValue={RowSizes.Compact}
          onClick={onClick}
        />
        <PaperFormatDropDown form={form} onClick={onClick} />
      </div>
    );
  },
});

export const PaperFormatDropDown = ({ form, onClick }) => {
  const { Letter, Legal, A4, A5 } = PageFormats;

  const pageFormatItems = [Letter, Legal, A4, A5].map((format) =>
    Map({
      type: 'link',
      content: PageFormatTitles[`${format}Title`],
      onClick: () => onClick('format', format),
    }),
  );

  const config = Map({
    noCaret: false,
    icon: null,
    content: PageFormatTitles[`${form.get('format')}Title`],
    items: pageFormatItems,
  });

  return (
    <div className="pdf-option-wrapper">
      <div className="pdf-option-title">Paper Size</div>
      <Dropdown className="generic-dropdown-menu" config={config} />
    </div>
  );
};

export const RadioToggle = ({
  title,
  field,
  firstValue,
  secondValue,
  form,
  onClick,
}) => {
  return (
    <div className="pdf-option-wrapper">
      <div className="pdf-option-title">{title}</div>
      <div className="pdf-radio-option-wrapper">
        <div
          className="pdf-radio-option"
          onClick={() => onClick(field, firstValue)}
        >
          <div
            className={`custom-pdf-radio-option ${
              form.get(field) === firstValue ? 'checked' : ''
            }`}
          />
          <div className="pdf-radio-option-title">{capitalize(firstValue)}</div>
        </div>
        <div
          className="pdf-radio-option"
          onClick={() => onClick(field, secondValue)}
        >
          <div
            className={`custom-pdf-radio-option ${
              form.get(field) === secondValue ? 'checked' : ''
            }`}
          />
          <div className="pdf-radio-option-title">
            {capitalize(secondValue)}
          </div>
        </div>
      </div>
    </div>
  );
};
